// ROOM 404: Mobile Bottom Navigation Bar (5 Core Tabs)

import React from 'react';
import { Compass, Lightbulb, MessageSquare, Shield, Target } from 'lucide-react';

export type NavTab = 'briefing' | 'rooms' | 'ideas' | 'missions' | 'identity';

interface NavigationProps {
  currentTab: NavTab;
  onTabChange: (tab: NavTab) => void;
  unreadRoomsCount?: number;
}

export const Navigation: React.FC<NavigationProps> = ({
  currentTab,
  onTabChange,
  unreadRoomsCount = 0,
}) => {
  const tabs: { id: NavTab; label: string; icon: any; badge?: number }[] = [
    { id: 'briefing', label: 'Briefing', icon: Compass },
    { id: 'rooms', label: 'Rooms', icon: MessageSquare, badge: unreadRoomsCount },
    { id: 'ideas', label: 'Ideas', icon: Lightbulb },
    { id: 'missions', label: 'Missions', icon: Target },
    { id: 'identity', label: 'Identity', icon: Shield },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-[#0c0e17]/95 backdrop-blur-md border-t border-[#1f2433] px-2 py-2 select-none">
      <div className="max-w-md mx-auto flex items-center justify-around">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = currentTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`relative flex flex-col items-center justify-center py-1 px-3 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'text-emerald-400 font-semibold'
                  : 'text-gray-400 hover:text-gray-200 active:scale-95'
              }`}
            >
              <div className="relative">
                <Icon className={`w-5 h-5 transition-transform ${isActive ? 'scale-110 stroke-[2.5]' : 'stroke-2'}`} />
                {Boolean(tab.badge && tab.badge > 0) && (
                  <span className="absolute -top-1 -right-2 bg-emerald-500 text-black text-[10px] font-bold px-1.5 py-0.2 rounded-full ring-2 ring-[#0c0e17]">
                    {tab.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] mt-1 tracking-tight ${isActive ? 'text-emerald-400' : 'text-gray-400'}`}>
                {tab.label}
              </span>
              {isActive && (
                <div className="w-1 h-1 bg-emerald-400 rounded-full mt-0.5 shadow-[0_0_8px_#10b981]" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
